import { useAppSelector } from '@/redux/hooks'
import RefundCard from './refund-components/refund-card/refund-card'
import TopBar from './refund-components/top-bar/top-bar'
import ReverCard from './refund-components/rever-card/rever-card'
import { usePortalTranslate } from '@/hooks'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'
import { useContext } from 'react'
import { Button } from '@/ui/components/portal-preview/pages/pages-components/button'

function RefundMethodPage() {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)

  const refundMethods = useAppSelector(
    (store) =>
      store.settingsApi.settings.response.refund?.payment_method_configs
  )

  const displayShippingTag = true

  return (
    <div>
      <TopBar page="refund-method" title={translate('refund_page_title')} />
      <div className="flex grow flex-col content-center items-center rounded-[0_0_3rem_3rem] bg-white">
        <ReverCard>
          {refundMethods
            ? refundMethods.map((method, i) => (
                <RefundCard
                  key={i}
                  method={method.name}
                  timing={method.timing}
                  displayShippingTag={displayShippingTag}
                />
              ))
            : null}
          <div className="mb-8 flex justify-center max-[374px]:w-full">
            <div className="w-full sm:w-fit">
              <Button id="refundMethodContinue">
                {translate('refund_page_button_continue')}
              </Button>
            </div>
          </div>
        </ReverCard>
      </div>
    </div>
  )
}

export default RefundMethodPage
